import React from 'react';
import './GetSupport.css';
import EyeIcon from '../../../../../assets/icons/gardenwall/eye.svg';

const GetSupport = ({ supportBlocksEnabled, onSupportBlockStatesChange }) => {
  const alerts = [
    { id: 1, slug: 'createTicket', title: 'Tickets', icon: 'ticket.svg' },
    { id: 2, slug: 'usageAnalysis', title: 'usageAnalysis', icon: 'usageAnalysis.svg' },
    { id: 3, slug: 'upgrade', title: 'Upgrade', icon: 'Upgrade-blue.svg' },
  ];

  return (
    <div className="card-content">
      <div className="alerts-grid">
        {alerts.map(alert => {
          let imagePath;
          try {
            imagePath = require(`../../../../../assets/icons/gardenwall/${alert.icon}`);
          } catch {
            imagePath = require(`../../../../../assets/icons/gardenwall/exm.svg`);
          }
          const isActive = supportBlocksEnabled?.[alert.slug] !== false;

          return (
            <div key={alert.id} className={`alert-card ${!isActive ? 'inactive' : ''}`}>
              <div className="alert-icon">
                <img src={imagePath} alt={`${alert.title} Icon`} />
              </div>
              <div className="alert-title">{alert.title}</div>
              <div
                className="alert-eye"
                onClick={() => onSupportBlockStatesChange(alert.slug)}
              >
                <img src={EyeIcon} alt="Eye Icon" />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default GetSupport;

